import { useState } from "react";
import { getDropdownSemanticOptionsFromData, useFetchData, useParseRouteActions } from "../../../helpers/GlobalHelper";
import LmsFormGenerator, { BCFormController } from "../ui/LmsFormGenerator";
import LmsTable from "../ui/LmsTable";
import LmsTabPages from "../ui/LmsTabPages";

const addInspectionProjectDetailsTableEditingFields = (myForm) => {
  myForm.addFormInputField("Line Number", { inlineEdit: true });
  return myForm;
};

const InspectionProjectDetailsTable = ({ apiSuffix }) => {
  return <LmsTable
    apiSuffix={apiSuffix}
    actionButtons={["export", "save", "cancel"]}
    saveSuffix="inspections/company-projects/details"
    myForm={addInspectionProjectDetailsTableEditingFields(new BCFormController())}
  />;
};

const companyDataMatchFormFields = (myForm) => {
  myForm.addCenteredGroup(
    [
      myForm.getCheckboxField("Show All Inspection Company Projects", { name: "showAllNWCCProjects", inlineRight: true }),
    ],
  );

  myForm.addCenteredGroup(
    [
      myForm.getCheckboxField("Show Matched Inspection Company Projects", { name: "ShowMatchedNWCCProjects", inlineRight: true }),
    ],
  );

  myForm.addCenteredGroup(
    [
      myForm.getCheckboxField("Show Mismatched Inspection Company Projects", { name: "ShowMismatchedNWCCProjects", inlineRight: true }),
    ],
  );

  myForm.addCenteredGroup(
    [
      myForm.getCheckboxField("Show Unchecked Inspection Company Projects", { name: "ShowUncheckedNWCCProjects", inlineRight: true }),
    ],
  );

  myForm.addCenteredGroup([
    myForm.getDropdownField("Inspection Company Project", [], {
      name: "nwccProjectId",
      required: true,
    }),
  ]);
  myForm.addDividerField({ dividerIsHidden: true });
  myForm.addDividerField({ dividerIsHidden: true });

  return myForm;
};

const CompanyDataMatchForm = () => {
  const [{ fetchData }] = useFetchData();
  const[nwccProjectId, setNwccProjectId] = useState(undefined as any);
  const myForm = companyDataMatchFormFields(
    new BCFormController({}, { submitSuffix: "inspections/update-nwcc-data-match-temp", blankWidth: 6, styles: { minHeight: "600px" } })
  );

  const onFormChanged = async (options, lastUpdated) => {
    const inputs = options?.inputs || {};
    if (lastUpdated !== "nwccProjectId") {
      const value = options?.inputs?.[lastUpdated];
      if (value === true) {
        setNwccProjectId(undefined);
        options?.setInputs({ [lastUpdated]: true, nwccProjectId: undefined });
        const inspectionCompanyProjectList = await fetchData("inspections/nwcc-projects", { fetchMethod: "POST", data: { [lastUpdated]: true } });
        if (inspectionCompanyProjectList) {
          options?.setAllDropdownOptionsData({ nwccProjectId: getDropdownSemanticOptionsFromData(inspectionCompanyProjectList.data) });
        }
        else {
          options?.setAllDropdownOptionsData({ nwccProjectId: [] });
          setNwccProjectId(undefined);
        }
      }
      else {
        options?.setAllDropdownOptionsData({ nwccProjectId: [] });
        setNwccProjectId(undefined);
      }
    }
    else {
      setNwccProjectId(inputs.nwccProjectId);
    }
  };

  const handleSubmitCompanyDataMatch = async (inputs, options) => {
    if (options.buttonText === "Mark As Mismatched") {
      inputs.actionButtonName = "Mismatched";
    }
    else if (options.buttonText === "Mark As Matched") {
      inputs.actionButtonName = "Matched";
    }
    else if (options.buttonText === "Next") {
      inputs.actionButtonName = "Next";
    }

    const { data: inspectionDataMatchTemp } = await fetchData("inspections/nwcc-data-match-temp", { fetchMethod: "POST", data: { ...inputs } });
    if (inspectionDataMatchTemp) {
      options.handleSubmit("inspections/update-nwcc-data-match-temp", {
        method: "PUT",
        data: { ...inputs, id: inspectionDataMatchTemp?.id },
        buttonText: options.buttonText,
        onSuccessFunc: options.onSuccessFunc
      });
    }
  };

  const fromActions = [
    { 
      text: "Mark As Matched",
      action: "save"
    },
    { 
      text: "Mark As Mismatched",
      action: "save"
    },
    { 
      text: "Next",
      action: "save"
    },
    "close"
  ];

  const tabPages = {
    Details: <InspectionProjectDetailsTable apiSuffix={`inspections/inspection-company-data-match-details/${nwccProjectId}`} /> 
  };

  return (
    <>
      <LmsFormGenerator
        myForm={myForm}
        actions={nwccProjectId ? fromActions : ["close"]}
        onFormChanged={onFormChanged}
        handleSubmit={handleSubmitCompanyDataMatch}
      />
      {(tabPages && nwccProjectId) && <LmsTabPages tabPages={tabPages}/>}
    </>
  );
};

const LmsInspectionsInspectionCompanyDataMatch = ({ params = {}, history }) => {
  const { isActionAllowed } = useParseRouteActions(params);
  if (!isActionAllowed) {
    history.goBack();
  }

  return (<CompanyDataMatchForm />);
};

export default LmsInspectionsInspectionCompanyDataMatch;